import { LogOut, User, Eye, ArrowLeft } from 'lucide-react';
import { useAuth } from '@/shared/contexts/AuthContext';
import { useState } from 'react';

export function ClientHeader() {
  const { user, logout, impersonatedBy, exitImpersonation } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b bg-card">
      {/* Impersonation Banner */}
      {impersonatedBy && (
        <div className="bg-amber-500 text-white px-6 py-2 flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Eye className="h-4 w-4" />
            <span className="text-sm font-medium">
              Visualizando como: {user?.name} ({user?.email})
            </span>
            <span className="text-sm opacity-90">• Você: {impersonatedBy.name}</span>
          </div>
          <button
            onClick={exitImpersonation}
            className="flex items-center space-x-1 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-md transition-colors text-sm font-medium"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Sair da visualização</span>
          </button>
        </div>
      )}
      <div className="flex h-16 items-center justify-between px-6">
        {/* Logo/Brand */}
        <div className="flex items-center space-x-3">
          <img src="/ugoo-branco.svg" alt="TravelLegacy" className="h-10 w-auto" />
        </div>

        {/* Right side - User menu */}
        <div className="flex items-center space-x-4">

          {/* User Menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center space-x-2 rounded-lg px-3 py-2 hover-icon transition-colors"
            >
              <div className="h-8 w-8 rounded-full bg-primary flex items-center justify-center text-primary-foreground text-sm font-bold">
                {user?.name.charAt(0).toUpperCase()}
              </div>
              <div className="text-left hidden sm:block">
                <p className="text-sm font-medium text-card-foreground">{user?.name}</p>
                <p className="text-xs text-muted-foreground">Cliente</p>
              </div>
            </button>

            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-card rounded-lg shadow-lg border py-1">
                <div className="px-4 py-2 border-b">
                  <p className="text-sm font-medium text-card-foreground">{user?.name}</p>
                  <p className="text-xs text-muted-foreground">{user?.email}</p>
                </div>
                <button
                  onClick={() => {
                    setShowUserMenu(false);
                    // Profile page (future)
                  }}
                  className="w-full text-left px-4 py-2 text-sm text-card-foreground hover-menu flex items-center"
                >
                  <User className="h-4 w-4 mr-2" />
                  Perfil
                </button>
                <button
                  onClick={() => {
                    setShowUserMenu(false);
                    logout();
                  }}
                  className="w-full text-left px-4 py-2 text-sm text-destructive hover:bg-destructive/10 flex items-center"
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  Sair
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
